/* global site */
var ctrlopt = ctrlopt;

(function ($) {
  var pCounterId, pAppointmentId, pToken, pStoreNumber,
    loc = window.parent.location !== window.location ? window.parent.location : window.location,
    nextSection = 'counters',
    apptBook = Drupal.appointmentBooking,
    modelSectionData = [
      {
        id: 'counters',
        jqElem: $('#counters')
      },
      {
        id: 'services',
        jqElem: $('#services')
      },
      {
        id: 'appointments',
        jqElem: $('#appointments')
      },
      {
        id: 'confirmation',
        jqElem: $('#confirmation')
      }

    ];

  function getURLParam(oTarget, sVar) {
    return decodeURI(oTarget.search.replace(new RegExp('^(?:.*[&\\?]' + encodeURI(sVar).replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1'));
  }

  pCounterId = getURLParam(loc, 'counter_id');
  pStoreNumber = getURLParam(loc, 'store_number');
  pAppointmentId = getURLParam(loc, 'appointment_id');
  pToken = getURLParam(loc, 'token');

  Drupal.behaviors.apptBook = {
    attach: function () {
      var updateObj,
        updateParams = null,
        hasCounters = false,
        hasServices = false,
        container = $('#appointment-book-container'),
        sectionsContainer = $('#appointment-book-sections'),
        sections = sectionsContainer.find('.appt-book-section'),
        sectionManager = apptBook.sectionManager.init(sectionsContainer, sections),
        mData = { data: modelSectionData };

      if (pToken) {
        mData.token = pToken;
      }

      function setCounters(data) {
        if (!data || !data.length) {
          window.location = '/';

          return;
        }
        hasCounters = true;
        if (hasServices) {
          run();
        }
      }

      function setServices() {
        hasServices = true;
        if (hasCounters) {
          run();
        }
      }

      function run() {
        var currentSection, $header, $dots, $title, $subhead, isMobile;

        sectionManager.setModel(apptBook.sectionModel).startObserving();
        apptBook.historyHandler.setModel(apptBook.sectionModel).startObserving();

        if (pStoreNumber) {
          var foundCounterByNumber = apptBook.sectionModel.countersData.filter(function (element) {
            return element.store_no === pStoreNumber;
          })[0];

          if (foundCounterByNumber) {
            pCounterId = foundCounterByNumber.id;
          }
        }

        if (pCounterId) {
          nextSection = 'services';
          updateParams = {
            sectionId: nextSection,
            counterId: pCounterId
          };
        }

        if (pAppointmentId) {
          nextSection = 'appointments';
          updateParams = {
            appointmentId: pAppointmentId
          };
        }

        updateObj = {
          sectionId: nextSection,
          params: updateParams
        };

        // Subscribe to sectionModel update events and update the page header and the page indication dots
        apptBook.sectionModel.on('update', function (data) {
          var config = Drupal.settings.appointment_booking_main_collection,
            section = data.sectionId;

          if (section === currentSection) {
            return;
          }

          var isVirtual = 0;

          if (section === 'confirmation') {
            if (data.params.counter.calendars[0].virtual === '1') {
              isVirtual = 1;
            }
          }

          $header = $('.appt-book-page-header');
          $dots = $('.appt-book-page-header-content__dots', $header);
          $title = $('.appt-book-page-header-content__title', $header);
          $subhead = $('.appt-book-page-header-content__subhead', $header);
          // isMobile = Unison.fetch.now().name === 'small';
          isMobile = site.client.isMobile;

          if (isMobile) {
            $title = $('span', $title);
          }

          var s = {};

          for (var key in config) {
            if (!config.hasOwnProperty(key)) {
              continue;
            }

            s = config[key];
            if (s['section_key'] == section) {
              break;
            }
          }

          if (!$.isEmptyObject(s)) {
            $dots.show();

            var i = s['section_number'];

            if (i.length > 0) {
              $('li', $dots)
                .removeClass('active')
                .addClass('disabled')
                .filter('.dot--' + i)
                .addClass('active')
                .removeClass('disabled');
            } else {
              $('li', $dots).removeClass('active');
            }

            $title.html(s['section_title']);
            if (isVirtual) {
              $subhead.html(s['section_subhead_virtual']);
            } else {
              $subhead.html(s['section_subhead']);
            }
          }

          currentSection = section;
        });

        apptBook.sectionModel.update(updateObj);
      }

      apptBook.sectionModel.on('data_set', function () {
        apptBook.sectionModel.off('data_set');
        apptBook.sectionModel.getCounters(setCounters);
        apptBook.sectionModel.getServices(setServices);
      });

      apptBook.sectionModel.setData(mData);
    }
  };
})(jQuery);
